import React from 'react';

import { CircularProgress, Dialog, useMediaQuery } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()({
  dialog: {},
});

function LoadingDialog() {
  const downXs = useMediaQuery(theme => theme.breakpoints.down('md'));
  const { classes } = useStyles();
  return (
    <Dialog className={classes.dialog} fullScreen={downXs} open={!false}>
      <CircularProgress />
    </Dialog>
  );
}

export default LoadingDialog;
